import React, { useEffect, useState } from 'react';
import { Gift, ArrowRight } from 'lucide-react';
import { usePriceConfig } from './PriceContext';
export function StickyBonusCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const price = usePriceConfig();
  useEffect(() => {
    const handleScroll = () => {
      const bonusSection = document.getElementById('bonus-section');
      if (!bonusSection) return;
      const rect = bonusSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      // Show button when bonus section is in viewport
      const shouldShow = rect.top < windowHeight && rect.bottom > 0;
      setIsVisible(shouldShow);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-500 ease-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-206">
      <div className="bg-[#8B5A2B] border-t-4 border-[#6F6F6F] shadow-[0_-8px_32px_rgba(0,0,0,0.9)]" data-id="element-207">
        <div className="max-w-7xl mx-auto px-4 py-3 md:py-4" data-id="element-208">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-6" data-id="element-209">
            {/* Left side - Message */}
            <div className="flex items-center gap-2 md:gap-3 text-center md:text-left" data-id="element-210">
              <Gift className="w-6 h-6 md:w-8 md:h-8 text-[#E4D6B5] flex-shrink-0 hidden md:block" data-id="element-211" />
              <div data-id="element-212">
                <p className="text-xs md:text-base font-black text-[#E4D6B5] uppercase tracking-wide" data-id="element-213">
                  Método Carpintería Plegable + 9 BONOS 🎁
                </p>
                <p className="text-[10px] md:text-sm text-[#E4D6B5] font-semibold" data-id="element-214">
                  Solo disponibles con tu orden de hoy
                </p>
              </div>
            </div>

            {/* Right side - CTA Button */}
            <a href="https://fabricaindustrial.com/cart/add?id=53066804855123&quantity=1&return_to=/cart" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart');
            }
          }} className="inline-flex items-center justify-center gap-2 bg-[#111111] hover:bg-[#0a0a0a] text-[#E4D6B5] font-bold text-sm md:text-base py-3 px-6 md:px-8 border-2 md:border-4 border-[#6F6F6F] shadow-[0_4px_0_0_#0a0a0a] hover:shadow-[0_2px_0_0_#0a0a0a] hover:translate-y-1 transition-all duration-200 uppercase tracking-wider whitespace-nowrap" data-id="element-215">
              OBTENER TODO POR SOLO {price.main}
              <ArrowRight className="w-4 h-4 md:w-5 md:h-5" data-id="element-216" />
            </a>
          </div>
        </div>
      </div>
    </div>;
}